import { useFormik } from 'formik'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import logo from '../../assets/svg/NEMA.svg'
import api from '../../utils/api'
import styles from './Signup.module.css'

const validationSchema = Yup.object({
  username_str: Yup.string().required('Username is required'),
  email_id: Yup.string().email('Invalid email format').required('Email is required'),
  password: Yup.string().required('Password is required'),
  confirm_password: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords must match'),
  role: Yup.string().required('Role is required'),
  secret_key_id: Yup.string().required('Key is required'),
})

const Signup = () => {
  const [error, setError] = useState('')

  const handleSubmit = async (values) => {
    const { confirm_password, ...data } = { ...values, role: values.role.toLowerCase() }

    try {
      await api.post(`signup_admin`, data)
      setError('')
    } catch (error) {
      console.error(error)
      setError(error.response?.data?.error || 'Signup failed. Please try again.')
    }
  }

  const formik = useFormik({
    initialValues: { username_str: '', email_id: '', password: '', confirm_password: '', role: '', secret_key_id: '' },
    validationSchema,
    onSubmit: handleSubmit,
  })

  return (
    <div className={styles.loginPage}>
      <div className={styles.logoContainer}>
        <img src={logo} alt='Logo' className={styles.logo} />
      </div>
      <div className={styles.container}>
        <h2 className={styles.title}>Welcome to Nema Admin</h2>
        <p className={styles.subtitle}>Please create your account</p>
        {error && <div className={styles.globalError}>{error}</div>}
        <form onSubmit={formik.handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='username_str'>
              Name
            </label>
            <div className={styles.inputGroup}>
              <input
                id='username_str'
                name='username_str'
                type='text'
                className={styles.input}
                placeholder='Your Name'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.username_str}
              />
            </div>
            {formik.touched.username_str && formik.errors.username_str && <div className={styles.error}>{formik.errors.username_str}</div>}
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='email_id'>
              Email
            </label>
            <div className={styles.inputGroup}>
              <input
                id='email_id'
                name='email_id'
                type='email'
                className={styles.input}
                autoFocus
                autoComplete='email'
                placeholder='Your admin email'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email_id}
              />
            </div>
            {formik.touched.email_id && formik.errors.email_id && <div className={styles.error}>{formik.errors.email_id}</div>}
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='password'>
              Password
            </label>
            <div className={styles.inputGroup}>
              <input
                id='password'
                name='password'
                type='password'
                className={styles.input}
                autoComplete='password'
                placeholder='Your secure password'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
            </div>
            {formik.touched.password && formik.errors.password && <div className={styles.error}>{formik.errors.password}</div>}
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='confirm_password'>
              Confirm Password
            </label>
            <div className={styles.inputGroup}>
              <input
                id='confirm_password'
                name='confirm_password'
                type='password'
                className={styles.input}
                autoComplete='password'
                placeholder='Your secure password'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirm_password}
              />
            </div>
            {formik.touched.confirm_password && formik.errors.confirm_password && <div className={styles.error}>{formik.errors.confirm_password}</div>}
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='role'>
              Role
            </label>
            <div className={styles.inputGroup}>
              <input
                id='role'
                name='role'
                type='text'
                className={styles.input}
                placeholder='Your role'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.role}
              />
            </div>
            {formik.touched.role && formik.errors.role && <div className={styles.error}>{formik.errors.role}</div>}
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor='secret_key_id'>
              Key
            </label>
            <div className={styles.inputGroup}>
              <input
                id='secret_key_id'
                name='secret_key_id'
                type='text'
                className={styles.input}
                placeholder='Your Key'
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.secret_key_id}
              />
            </div>
            {formik.touched.secret_key_id && formik.errors.secret_key_id && <div className={styles.error}>{formik.errors.secret_key_id}</div>}
          </div>

          <button type='submit' className={styles.button} disabled={!formik.isValid || formik.isSubmitting}>
            {formik.isSubmitting ? 'Signing up...' : 'Sign up'}
          </button>
        </form>

        <p className={styles.signupText}>
          Already have an account? <NavLink to='/admin/login'>Log in</NavLink>
        </p>
      </div>
    </div>
  )
}

export default Signup
